var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPortfoliosWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_340_1163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.75 2.75V6.41667C13.75 6.65978 13.8466 6.89294 14.0185 7.06485C14.1904 7.23676 14.4236 7.33333 14.6667 7.33333H18.3333",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 15.5833H10.0833C9.5971 15.5833 9.13079 15.3902 8.78697 15.0464C8.44315 14.7025 8.25 14.2362 8.25 13.75V4.58333C8.25 4.0971 8.44315 3.63079 8.78697 3.28697C9.13079 2.94315 9.5971 2.75 10.0833 2.75H13.75L18.3333 7.33333V13.75C18.3333 14.2362 18.1402 14.7025 17.7964 15.0464C17.4525 15.3902 16.9862 15.5833 16.5 15.5833Z",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6668 15.5832V17.4165C14.6668 17.9027 14.4737 18.369 14.1299 18.7129C13.786 19.0567 13.3197 19.2498 12.8335 19.2498H6.41683C5.9306 19.2498 5.46428 19.0567 5.12047 18.7129C4.77665 18.369 4.5835 17.9027 4.5835 17.4165V8.24984C4.5835 7.76361 4.77665 7.29729 5.12047 6.95347C5.46428 6.60966 5.9306 6.4165 6.41683 6.4165H8.25016",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_340_1163"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPortfoliosWhite);
export default __webpack_public_path__ + "static/media/Icon_Portfolios_White.87dc4de1a3e3fdf7edc4ab83ce410c13.svg";
export { ForwardRef as ReactComponent };